import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NotificationFacade } from '@core/facades/notification.facade';
import { LoadingService } from '@core/services/loading.service';
import { TransactionsService } from '@core/services/transactions.service';
import { ButtonDirective } from '@shared/directives/button.directive';
import { PermissionDirective } from '@shared/directives/permission.directive';
import { InputLabelComponent } from '@shared/ui/input-label/input-label.component';
import { InputComponent } from '@shared/ui/input/input.component';
import { SlideInRightModalComponent } from '@shared/ui/slide-in-right-modal/slide-in-right-modal.component';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-repush-transaction',
  standalone: true,
  imports: [
    SlideInRightModalComponent,
    InputLabelComponent,
    InputComponent,
    ReactiveFormsModule,
    CommonModule,
    ButtonDirective,
    PermissionDirective
  ],
  templateUrl: './repush-transaction.component.html',
  styleUrl: './repush-transaction.component.scss'
})
export class RepushTransactionComponent implements OnDestroy{
  fb = inject(FormBuilder)
  transactionService = inject(TransactionsService)
  notify = inject(NotificationFacade)
  loadingService = inject(LoadingService)

  isLoading$!: Observable<boolean>;
  subs: Subscription[] = []


  repushForm = this.fb.nonNullable.group({
    session_id: ['', Validators.required]
  })

  constructor() {
    this.isLoading$ =
      this.loadingService.getLoadingObservable('repush-transaction');
  }


  repushTransaction() {
    this.loadingService.setLoading('repush-transaction', true)
    const sub = this.transactionService.repushTransaction(this.repushForm.getRawValue().session_id).subscribe({
      next: (res) => {
        this.notify.success("Transaction set for repush successfully")
        this.loadingService.setLoading('repush-transaction', false)

      },
      error: (err) => {
        this.notify.error("An error occured while repushing transaction")
        this.loadingService.setLoading('repush-transaction', false)

      }
    })
    this.subs.push(sub)
  }

  ngOnDestroy() {
    this.subs.forEach((sub => sub.unsubscribe()))
  }
}
